<div class="email-rule">
  <p class="rule-description">
    Enable the feature for specific email addresses. The feature will be enabled for users with these emails.
  </p>

  <div class="email-input-container">
    <label for="new-email">Add Email:</label>
    <div class="input-group">
      <input
        type="text"
        id="new-email"
        [formControl]="newEmailControl"
        placeholder="Enter email address"
        (keydown.enter)="onInputKeydown($event)"
      />
      <button mat-flat-button color="primary" type="button" (click)="addEmail()">Add</button>
    </div>
    <div *ngIf="emailError" class="email-error">{{ emailError }}</div>
  </div>

  <div class="emails-container">
    <div class="emails-header" *ngIf="emails && emails.length > 0">
      <h4>Target Emails ({{ emails.length }})</h4>
      <button id="e2e-clear-all-email" mat-button color="primary" type="button" (click)="clearEmails()">
        Clear All
      </button>
    </div>

    <div class="email-pills" *ngIf="emails && emails.length > 0">
      <ul>
        <li *ngFor="let email of emails; let i = index">
          {{ email }}
          <button
            [id]="'e2e-clear-all-email_{{index}}'"
            mat-button
            color="primary"
            type="button"
            (click)="removeEmail(i)"
          >
            Remove
          </button>
        </li>
      </ul>
    </div>

    <div class="no-emails" *ngIf="!emails || emails.length === 0">
      <p>No emails added yet. Add emails to target specific users.</p>
    </div>
  </div>
</div>
